import { defineComponent as _defineComponent } from 'vue'
import { PaymentMethodInfo } from '@/services/billing-utils';
import { PropType } from 'vue';
import PaymentMethodBankTransfer from './PaymentMethodBankTransfer.vue';
import PaymentMethodCard from './PaymentMethodCard.vue';
import PaymentMethodSepaDebit from './PaymentMethodSepaDebit.vue';
import PaymentMethodUnknown from './PaymentMethodUnknown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMethodsList',
  props: {
  paymentMethodInfos: { type: Array as PropType<Array<PaymentMethodInfo>>, required: true },
  showControls: { type: Boolean, required: false, default: false },
  bankTransferAllowed: { type: Boolean, required: true },
  bankTransferOnTop: { type: Boolean, required: false, default: false },
},
  emits: ['method:delete', 'method:set-default'],
  setup(__props, { emit }) {

const props = __props;






return { __sfc: true,emit, props, PaymentMethodBankTransfer, PaymentMethodCard, PaymentMethodSepaDebit, PaymentMethodUnknown }
}

})